import React from 'react';

import DashboardByModule from '../../../NTX/DashboardManagament/DashboardListByModule/DashboardByModule';
import useGetDashboardWithPermission from '../../../../hooks/NTX/Dashboard/useGetDashboardWithPermission';

//________________ Start Components
const PayrollDashboard: React.FC = () => {
  const { DashboardWithPermission } = useGetDashboardWithPermission();
  // 0A6C6B89-1D52-4EAA-8D2C-011C74B1F6E0
  const dashboardListByModule = DashboardWithPermission?.filter(
    (f) => f?.moduleId?.toLowerCase() === '0a6c6b89-1d52-4eaa-8d2c-011c74b1f6e0'
    // (f) => f?.moduleId === null
  );

  return (
    <div>
      <DashboardByModule dashboardList={dashboardListByModule} />
    </div>
  );
};

export default PayrollDashboard;
